import {forgotStart} from "features/pages/account/forgot-password/reducer";
import {takeLatest, takeEvery, debounce} from "redux-saga/effects";
import {forgotPasswordSaga} from "features/pages/account/forgot-password/saga";
import {loginSaga} from "features/pages/account/login/saga";
import {loginStart, loginSuccess} from "features/pages/account/login/reducer";
import {tempPasswordSaga} from "features/pages/account/temp-password/saga";
import {tempPasswordStart, tempPasswordSuccess} from "features/pages/account/temp-password/reducer";
import {authRedirect} from "store/reducer/auth/saga";
import {resetAuth} from "store/reducer/auth/reducer";
import {signupSaga} from "features/pages/account/signup/saga";
import {signupDone, signupStart} from "features/pages/account/signup/reducer";
import {
    generateQrCodeStart,
    getProfileStart,
    saveProfileStart,
    saveProfileSuccess
} from "store/reducer/user/profile/reducer";
import {generateQrCodeSaga, getProfileSaga, saveProfileSaga} from "store/reducer/user/profile/saga";
import {
    getCompaniesStart, startDeleteCompany,
    startResetCompanyCode, successDeleteCompany, successResetCompanyCode,
    upsertCompanyStart,
    upsertCompanySuccess
} from "store/reducer/company/reducer";
import {
    companyChangeSecretCodeSaga,
    companyDeleteSaga,
    getCompaniesSaga,
    upsertCompanySaga
} from "store/reducer/company/saga";
import {startAssociateCompany, successAssociateCompany} from "features/modals/company/associate/reducer";
import {associateCompanySaga} from "features/modals/company/associate/saga";
import {disassociateCompanySaga} from "features/modals/company/disassociate/saga";
import {startDisassociateCompany, successDisassociateCompany} from "features/modals/company/disassociate/reducer";
import {onboardingCompleteSaga} from "features/pages/account/onboarding/saga";
import {onboardingCompleteStart} from "features/pages/account/onboarding/reducer";
import {disassociateUserSaga} from "features/modals/company/disassociate-user/saga";
import {startDisassociateUser, successDisassociateUser} from "features/modals/company/disassociate-user/reducer";
import {downloadStaticData} from "store/reducer/static/reducer";
import {downloadInterestsSaga, downloadSkillsSaga} from "store/reducer/static/saga";
import {getHomeDataSaga} from "features/pages/home/saga";
import {getHomeDataStart} from "features/pages/home/reducer";
import {favoriteVideoStart} from "store/reducer/video/favorite/reducer";
import {favoriteVideoSaga} from "store/reducer/video/favorite/saga";
import {searchVideoFiltersSetSaga, searchVideoSaga} from "features/pages/videos/saga";
import {setVideoSearchFilters, startVideosSearch, videoSearchFetchNextPage} from "features/pages/videos/reducer";
import {getSingleVideoSaga, setSingleVideoProgressSaga} from "features/pages/single-video/saga";
import {setSingleVideoProgress, startSingleVideo} from "features/pages/single-video/reducer";
import {likeVideoStart} from "store/reducer/video/like/reducer";
import {likeVideoSaga} from "store/reducer/video/like/saga";
import {commentSet, commentStart, commentSuccess} from "features/components/comment-field/reducer";
import {autosuggestCommentTagSaga} from "features/components/comment-field/comment-autosuggest/saga";
import {sendCommentSaga} from "features/components/comment-field/saga";
import {commentsListSaga} from "features/components/comment-box/saga";
import {getCommentsFetchNextPage, getCommentsStart, setCommentsOrderBy} from "features/components/comment-box/reducer";
import {deleteCommentSaga} from "store/reducer/comments/delete/saga";
import {deleteCommentStart, deleteCommentSuccess} from "store/reducer/comments/delete/reducer";
import {startCommentEdit, successCommentEdit} from "features/modals/comment-edit/reducer";
import {commentEditSaga} from "features/modals/comment-edit/saga";
import {getSingleDirectorySaga} from "features/pages/single-directory/saga";
import {startSingleDirectory} from "features/pages/single-directory/reducer";
import {getPaymentDataStart} from "features/pages/payment/reducer";
import {getPaymentDataSaga} from "features/pages/payment/saga";
import {doPaySaga} from "store/reducer/payments/pay/saga";
import {doPayStart, doPaySuccess} from "store/reducer/payments/pay/reducer";
import {getSuggestedStart} from "features/components/suggested/reducer";
import {getSuggestedSaga} from "features/components/suggested/saga";
import {searchAllSaga} from "features/modals/search/saga";
import {searchAllStart} from "features/modals/search/reducer";
import {favoriteEventStart} from "store/reducer/event/favorite/reducer";
import {favoriteEventSaga} from "store/reducer/event/favorite/saga";
import {eventsSearchFetchNextPage, setEventsSearchFilters, startEventsSearch} from "features/pages/events/reducer";
import {searchEventsFiltersSetSaga, searchEventsSaga} from "features/pages/events/saga";
import {startSingleEvent} from "features/pages/single-event/reducer";
import {getSingleEventSaga} from "features/pages/single-event/saga";
import {likeEventSaga} from "store/reducer/event/like/saga";
import {likeEventStart} from "store/reducer/event/like/reducer";
import {setProfileSettingsStart} from "store/reducer/user/settings/reducer";
import {setProfileSettingsSaga} from "store/reducer/user/settings/saga";
import {getPublicProfileSaga} from "features/pages/profile-public/saga";
import {getPublicProfileStart} from "features/pages/profile-public/reducer";
import {getUserSubscriptionStart} from "store/reducer/user/subscription/reducer";
import {getUserSubscriptionSaga} from "store/reducer/user/subscription/saga";
import {changePasswordStart} from "features/modals/change-password/reducer";
import {changePasswordSaga} from "features/modals/change-password/saga";
import {saveInvoiceDataSaga} from "store/reducer/payments/invoice/saga";
import {saveInvoiceDataStart} from "store/reducer/payments/invoice/reducer";
import {
    addNewPaymentMethodStart,
    addNewPaymentMethodSuccess,
    deletePaymentMethodStart, deletePaymentMethodSuccess
} from "store/reducer/payments/cards/reducer";
import {addNewPaymentMethodSaga, removePaymentMethodSaga} from "store/reducer/payments/cards/saga";
import {deleteAccountStart} from "features/modals/delete-account/reducer";
import {deleteAccountSaga} from "features/modals/delete-account/saga";
import {notificationCountSaga} from "store/reducer/notifications/count/saga";
import {notificationCountStart} from "store/reducer/notifications/count/reducer";
import {notificationListSaga} from "store/reducer/notifications/list/saga";
import {notificationListFetchNextPage, notificationListStart} from "store/reducer/notifications/list/reducer";
import {notificationDeleteStart, notificationDeleteSuccess} from "store/reducer/notifications/delete/reducer";
import {notificationDeleteSaga} from "store/reducer/notifications/delete/saga";
import {resetPasswordSaga} from "features/pages/account/reset-password/saga";
import {resetPasswordStart} from "features/pages/account/reset-password/reducer";
import {
    setThreadsSearchFilters,
    startThreadsSearch,
    threadsSearchFetchNextPage
} from "features/pages/threads/search/reducer";
import {searchThreadsFiltersSetSaga, searchThreadsSaga} from "features/pages/threads/search/saga";
import {favoriteThreadStart} from "store/reducer/threads/favorite/reducer";
import {favoriteThreadSaga} from "store/reducer/threads/favorite/saga";
import {getArchiveThreadsSaga} from "features/pages/threads/archive/saga";
import {startThreadsSearchArchive, threadsSearchArchiveFetchNextPage} from "features/pages/threads/archive/reducer";
import {startThreadsHighlightGet} from "features/pages/threads/highlights/reducer";
import {getHighlightedThreadsSaga} from "features/pages/threads/highlights/saga";
import {getSingleThreadSaga} from "store/reducer/threads/single/saga";
import {startSingleThread} from "store/reducer/threads/single/reducer";
import {upsertThreadSaga} from "store/reducer/threads/upsert/saga";
import {upsertThreadStart} from "store/reducer/threads/upsert/reducer";
import {likeThreadStart} from "store/reducer/threads/like/reducer";
import {likeThreadSaga} from "store/reducer/threads/like/saga";
import {deleteThreadSaga} from "store/reducer/threads/delete/saga";
import {deleteThreadStart} from "store/reducer/threads/delete/reducer";
import {archiveThreadSaga} from "features/modals/thread-archive/saga";
import {threadArchiveStart, threadArchiveSuccess} from "features/modals/thread-archive/reducer";
import {voteCommentSaga} from "store/reducer/comments/vote/saga";
import {voteCommentStart} from "store/reducer/comments/vote/reducer";
import {getThreadsLeaderboardsSaga} from "features/pages/threads/leaderboards/saga";
import {startThreadsLeaderboardsGet} from "features/pages/threads/leaderboards/reducer";
import {startThreadsFavoritesGet} from "features/pages/threads/favorite/reducer";
import {getFavoritesThreadsSaga} from "features/pages/threads/favorite/saga";
import {getFaqSaga} from "features/pages/help/saga";
import {startFaqGet} from "features/pages/help/reducer";
import {startPeopleHighlightGet} from "features/pages/people/highlights/reducer";
import {getHighlightedPeopleSaga} from "features/pages/people/highlights/saga";
import {startPeopleFavoritesGet} from "features/pages/people/favorite/reducer";
import {getFavoritesPeopleSaga} from "features/pages/people/favorite/saga";
import {
    peopleSearchFetchNextPage,
    setPeopleSearchFilters,
    startPeopleSearch
} from "features/pages/people/search/reducer";
import {searchPeopleFiltersSetSaga, searchPeopleSaga} from "features/pages/people/search/saga";
import {getPrivateProfileRecommendationStatusSaga, getPrivateProfileSaga} from "features/pages/single-people/saga";
import {getPrivateProfileRecommendationStart, getPrivateProfileStart} from "features/pages/single-people/reducer";
import {skillConfirmStart} from "store/reducer/skills/confirm/reducer";
import {confirmSkillSaga} from "store/reducer/skills/confirm/saga";
import {favoritePeopleStart} from "store/reducer/people/favorite/reducer";
import {favoritePeopleSaga} from "store/reducer/people/favorite/saga";
import {recommendationRequestSaga} from "store/reducer/recommendation/request/saga";
import {recommendationRequestStart, recommendationRequestSuccess} from "store/reducer/recommendation/request/reducer";
import {sendMessageStart} from "features/modals/send-message/reducer";
import {sendMessageSaga} from "features/modals/send-message/saga";
import {sendRecommendationSaga} from "features/modals/send-recommendation/saga";
import {sendRecommendationStart, sendRecommendationSuccess} from "features/modals/send-recommendation/reducer";
import {
    ignoreRecommendationRequestStart,
    ignoreRecommendationRequestSuccess
} from "store/reducer/recommendation/ignore_request/reducer";
import {ignoreRecommendationRequestSaga} from "store/reducer/recommendation/ignore_request/saga";
import {recommendationsDataSaga} from "store/reducer/recommendation/data/saga";
import {recommendationsDataStart} from "store/reducer/recommendation/data/reducer";
import {
    deleteRecommendationRequestStart,
    deleteRecommendationRequestSuccess
} from "store/reducer/recommendation/delete_request/reducer";
import {deleteRecommendationRequestSaga} from "store/reducer/recommendation/delete_request/saga";
import {deleteRecommendationSaga} from "store/reducer/recommendation/delete/saga";
import {deleteRecommendationStart, deleteRecommendationSuccess} from "store/reducer/recommendation/delete/reducer";
import {acceptRecommendationStart, acceptRecommendationSuccess} from "store/reducer/recommendation/accept/reducer";
import {acceptRecommendationSaga} from "store/reducer/recommendation/accept/saga";
import {
    setVisibilityRecommendationStart,
    setVisibilityRecommendationSuccess
} from "store/reducer/recommendation/visibility/reducer";
import {setVisibilityRecommendationSaga} from "store/reducer/recommendation/visibility/saga";

export function* sagas(){
    yield takeLatest(forgotStart.type, forgotPasswordSaga);
    yield takeLatest(loginStart.type, loginSaga);
    yield takeLatest(tempPasswordStart.type, tempPasswordSaga);
    yield takeLatest(signupStart.type, signupSaga);
    yield takeEvery([loginSuccess.type, tempPasswordSuccess.type, resetAuth.type, signupDone.type], authRedirect);
    yield takeLatest(resetPasswordStart.type, resetPasswordSaga);

    //Profile
    yield takeLatest([getProfileStart.type, saveProfileSuccess.type, doPaySuccess.type, addNewPaymentMethodSuccess.type, deletePaymentMethodSuccess.type], getProfileSaga);
    yield takeLatest(saveProfileStart.type, saveProfileSaga);
    yield takeLatest(generateQrCodeStart.type, generateQrCodeSaga);
    yield takeEvery(setProfileSettingsStart.type, setProfileSettingsSaga);
    yield takeLatest(getPublicProfileStart.type, getPublicProfileSaga);
    yield takeLatest(getUserSubscriptionStart.type, getUserSubscriptionSaga);
    yield takeLatest(changePasswordStart.type, changePasswordSaga);
    yield takeLatest(saveInvoiceDataStart.type, saveInvoiceDataSaga);
    yield takeLatest(deleteAccountStart.type, deleteAccountSaga);

    //Companies
    yield takeLatest([getCompaniesStart.type, successAssociateCompany.type, successDisassociateCompany.type,
        upsertCompanySuccess.type, successResetCompanyCode.type, successDisassociateUser.type, successDeleteCompany.type], getCompaniesSaga);
    yield takeLatest(startAssociateCompany.type, associateCompanySaga);
    yield takeLatest(startDisassociateCompany.type, disassociateCompanySaga);
    yield takeLatest(upsertCompanyStart.type, upsertCompanySaga);
    yield takeLatest(startResetCompanyCode.type, companyChangeSecretCodeSaga);
    yield takeLatest(startDisassociateUser.type, disassociateUserSaga);
    yield takeLatest(startDeleteCompany.type, companyDeleteSaga);

    //Onboarding
    yield takeLatest(onboardingCompleteStart.type, onboardingCompleteSaga);


    //Static
    yield takeLatest(downloadStaticData.type, downloadSkillsSaga);
    yield takeLatest(downloadStaticData.type, downloadInterestsSaga);
    yield takeLatest(startFaqGet.type, getFaqSaga);


    //Home
    yield takeLatest(getHomeDataStart.type, getHomeDataSaga);

    //Video
    yield takeEvery(favoriteVideoStart.type, favoriteVideoSaga);
    yield takeEvery(likeVideoStart.type, likeVideoSaga);
    yield takeLatest([videoSearchFetchNextPage.type, startVideosSearch.type], searchVideoSaga);
    yield debounce(400, setVideoSearchFilters.type, searchVideoFiltersSetSaga);
    yield takeLatest(startSingleVideo.type, getSingleVideoSaga);
    yield takeLatest(setSingleVideoProgress.type, setSingleVideoProgressSaga);

    //Comments
    yield takeLatest(commentSet.type, autosuggestCommentTagSaga);
    yield takeLatest(commentStart.type, sendCommentSaga);
    yield takeLatest([getCommentsStart.type, getCommentsFetchNextPage.type, commentSuccess.type, deleteCommentSuccess.type, successCommentEdit.type, setCommentsOrderBy.type], commentsListSaga);
    yield takeEvery(deleteCommentStart.type, deleteCommentSaga);
    yield takeLatest(startCommentEdit.type, commentEditSaga);
    yield takeLatest(voteCommentStart.type, voteCommentSaga);

    //Directory
    yield takeLatest(startSingleDirectory.type, getSingleDirectorySaga);

    //Payment
    yield takeLatest(getPaymentDataStart.type, getPaymentDataSaga);
    yield takeLatest(doPayStart.type, doPaySaga);
    yield takeLatest(addNewPaymentMethodStart.type, addNewPaymentMethodSaga);
    yield takeEvery(deletePaymentMethodStart.type, removePaymentMethodSaga);

    //Suggested
    yield takeLatest(getSuggestedStart.type, getSuggestedSaga);

    //Search All
    yield debounce(400, searchAllStart.type, searchAllSaga);

    //Events
    yield takeEvery(favoriteEventStart.type, favoriteEventSaga);
    yield takeLatest([eventsSearchFetchNextPage.type, startEventsSearch.type], searchEventsSaga);
    yield debounce(400, setEventsSearchFilters.type, searchEventsFiltersSetSaga);
    yield takeLatest(startSingleEvent.type, getSingleEventSaga);
    yield takeLatest(likeEventStart.type, likeEventSaga);

    //Notifications
    yield takeLatest(notificationCountStart.type, notificationCountSaga);
    yield takeLatest([notificationListStart.type, notificationListFetchNextPage.type, notificationDeleteSuccess.type], notificationListSaga);
    yield takeLatest(notificationDeleteStart.type, notificationDeleteSaga);

    //Threads
    yield takeLatest([threadsSearchFetchNextPage.type, startThreadsSearch.type], searchThreadsSaga);
    yield debounce(400, setThreadsSearchFilters.type, searchThreadsFiltersSetSaga);
    yield takeEvery(favoriteThreadStart.type, favoriteThreadSaga);
    yield takeLatest([threadsSearchArchiveFetchNextPage.type, startThreadsSearchArchive.type], getArchiveThreadsSaga);
    yield debounce(400, setThreadsSearchFilters.type, getArchiveThreadsSaga);
    yield takeLatest(startThreadsHighlightGet.type, getHighlightedThreadsSaga);
    yield takeLatest(startThreadsFavoritesGet.type, getFavoritesThreadsSaga);
    yield takeLatest([startSingleThread.type, threadArchiveSuccess.type], getSingleThreadSaga);
    yield takeLatest(upsertThreadStart.type, upsertThreadSaga);
    yield takeLatest(likeThreadStart.type, likeThreadSaga);
    yield takeLatest(deleteThreadStart.type, deleteThreadSaga);
    yield takeLatest(threadArchiveStart.type, archiveThreadSaga);
    yield takeLatest(startThreadsLeaderboardsGet.type, getThreadsLeaderboardsSaga);

    //People
    yield takeLatest(startPeopleHighlightGet.type, getHighlightedPeopleSaga);
    yield takeLatest(startPeopleFavoritesGet.type, getFavoritesPeopleSaga);
    yield takeLatest([peopleSearchFetchNextPage.type, startPeopleSearch.type], searchPeopleSaga);
    yield debounce(400, setPeopleSearchFilters.type, searchPeopleFiltersSetSaga);
    yield takeLatest(getPrivateProfileStart.type, getPrivateProfileSaga);
    yield takeEvery(favoritePeopleStart.type, favoritePeopleSaga);

    //Skills
    yield takeLatest(skillConfirmStart.type, confirmSkillSaga);

    //Recommendation
    yield takeLatest([getPrivateProfileRecommendationStart.type,
        recommendationRequestSuccess.type,
        sendRecommendationSuccess.type,
        ignoreRecommendationRequestSuccess.type], getPrivateProfileRecommendationStatusSaga);
    yield takeLatest(recommendationRequestStart.type, recommendationRequestSaga);
    yield takeLatest(sendRecommendationStart.type, sendRecommendationSaga);
    yield takeLatest(ignoreRecommendationRequestStart.type, ignoreRecommendationRequestSaga);
    yield takeLatest(deleteRecommendationRequestStart.type, deleteRecommendationRequestSaga);
    yield takeEvery(deleteRecommendationStart.type, deleteRecommendationSaga);
    yield takeEvery(acceptRecommendationStart.type, acceptRecommendationSaga);
    yield takeEvery(setVisibilityRecommendationStart.type, setVisibilityRecommendationSaga)
    yield takeLatest([recommendationsDataStart.type,
        sendRecommendationSuccess.type,
        ignoreRecommendationRequestSuccess.type,
        deleteRecommendationSuccess.type,
        acceptRecommendationSuccess.type,
        setVisibilityRecommendationSuccess.type,
        deleteRecommendationRequestSuccess.type
    ], recommendationsDataSaga);

    //Message
    yield takeLatest(sendMessageStart.type, sendMessageSaga);
}